import { Component, Input } from '@angular/core';
import { ClrSpinnerModule } from "@clr/angular";
import { NgIf } from "@angular/common";

@Component({
  selector: 'app-progress',
  standalone: true,
    imports: [
        ClrSpinnerModule,
        NgIf
    ],
  templateUrl: './progress.component.html',
  styleUrl: './progress.component.sass'
})
export class ProgressComponent {
  @Input() progress = 0;
}
